const SelectorCantidad = ({
    cantidad,
    max,
    onChange
}) => {

    return (
        <div className="d-flex align-items-center gap-2 selector-cantidad">

            <button
                type="button"
                className="btn btn-sm btn-outline-secondary rounded-circle"
                disabled={cantidad <= 0}
                onClick={() => onChange(cantidad - 1)}
                style={{
                    width: "32px",
                    height: "32px",
                    padding: 0
                }}
            >
                <i className="fa-solid fa-minus"></i>
            </button>

            <span
                className="fw-bold text-center"
                style={{
                    minWidth: "25px"
                }}
            >
                {cantidad}
            </span>

            <button
                type="button"
                className="btn btn-sm btn-outline-secondary rounded-circle"
                disabled={cantidad >= max}
                onClick={() => onChange(cantidad + 1)}
                style={{
                    width: "32px",
                    height: "32px",
                    padding: 0
                }}
            >
                <i className="fa-solid fa-plus"></i>
            </button>

        </div>
    );
};



export default SelectorCantidad;
